<template>
  <svg :style="iconStyle" :width="computedWidth" :height="computedHeight">
    <use :xlink:href="`#${name}`" />
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      required: false,
    },
    width: {
      type: [String, Number],
      required: false,
    },
  },
  methods: {
    formatValue(val) {
      if (val == null) return undefined;
      if (typeof val === 'number') return `${val}px`;
      return val;
    },
  },
  computed: {
    computedWidth() {
      const iconsSize = this.size ?? '1em';
      return this.formatValue(this.width) ?? iconsSize;
    },
    computedHeight() {
      if (this.width != null) {
        return undefined;
      }
      return this.size ?? '1em';
    },
    iconStyle() {
      const iconsSize = this.size ?? '1em';
      const width = this.computedWidth;
      const height = this.width != null ? 'auto' : iconsSize;

      return `width: ${width}; height: ${height};`;
    },
  },
};
</script>
